import React, {useEffect} from "react";
import Group53 from "../../assets/1 our.webp";
import Group51 from "../../assets/3 orange.webp";
import Group52 from "../../assets/2 Purple.webp";
import Group54 from "../../assets/4 cyan.webp";
import Grid from "../../assets/Grid.png";

const OurService = () => {
  return (
    <div className="py-5" style={{ backgroundImage: `url(${Grid})` }}>
      <div className="container">
        <h2 className="text-center fw-bold mb-5 text-dark" style={{fontSize:"28px"}}>Our Services and Solutions</h2>
        
        <div className="row align-items-center mb-4">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>Real Time Order Tracking</h3>
            <p className="fs-5 text-secondary mt-3">
            Track your parcels every step of the way with Packky’s live tracking. From pickup to drop-off, both you and your customers know exactly where the delivery is, reducing confusion and improving trust.
            </p>
          </div>
          <div className="col-md-6 text-center">
          <img src={Group53} className="img-fluid rounded" style={{ maxHeight: "350px" }} alt="Real Time Order Tracking" />
          </div>
        </div>

        <div className="row align-items-center mb-4 flex-md-row-reverse">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>Smart Route Optimization</h3>
            <p className="fs-5 text-secondary mt-3">
            Deliver faster with Packky’s advanced routing system. It automatically finds the most efficient path, helping you cut delivery time, save fuel costs, and handle multiple stops with ease.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img src={Group52} className="img-fluid rounded" style={{ maxHeight: "350px" }}alt="Smart Route Optimization" />
          </div>
        </div>

        <div className="row align-items-center mb-4">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>Driver Management</h3>
            <p className="fs-5 text-secondary mt-3">
            Easily manage your delivery fleet with real-time driver tracking and task assignment. Keep operations organized, boost driver productivity, and ensure deliveries stay on schedule.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img src={Group51} className="img-fluid rounded" style={{ maxHeight: "350px" }}alt="Driver Management" />
          </div>
        </div>

        <div className="row align-items-center mb-4 flex-md-row-reverse">
          <div className="col-md-6 text-md-start text-center service-card-67">
            <h3 className="fw-bold" style={{fontSize:"24px"}}>Customer Notifications</h3>
            <p className="fs-5 text-secondary mt-3">
            Keep your customers in the loop with timely alerts about their delivery status. From dispatch to doorstep, notifications ensure clear communication and happier recipients.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img src={Group54} className="img-fluid rounded" style={{ maxHeight: "350px" }}alt="Customer Notifications" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurService;
